import React from "react"

const Footer = () => (
    <footer>
        Chris Bartlett &copy; { new Date().getFullYear()} Full-Stack Web Developer
    </footer>
)
  

export default Footer